import {
  AlertDialog as AlertDialogUI,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
interface IProps {
  showDialog: boolean;
  setShowDialog: (showExitDialog: boolean) => void;
  onConfirm: () => void;
  onCancel?: () => void;
  title: string;
  description: string;
  cancelText?: string;
  actionText?: string;
  secondaryActionText?: string;
  onSecondaryAction?: () => void;
  secondaryActionDisabled?: boolean;
  secondaryActionLoading?: boolean;
}

export const AlertDialog: React.FC<IProps> = ({
  showDialog,
  setShowDialog,
  onConfirm,
  onCancel,
  title,
  description,
  cancelText = "Cancel",
  actionText = "Confirm",
  secondaryActionText,
  onSecondaryAction,
  secondaryActionDisabled = false,
  secondaryActionLoading = false,
}) => {
  return (
    <AlertDialogUI open={showDialog} onOpenChange={setShowDialog}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>{cancelText}</AlertDialogCancel>
          {secondaryActionText && onSecondaryAction ? (
            <Button
              type="button"
              variant="secondary"
              onClick={onSecondaryAction}
              disabled={secondaryActionDisabled}
              loading={secondaryActionLoading}
            >
              {secondaryActionText}
            </Button>
          ) : null}
          <AlertDialogAction onClick={onConfirm}>{actionText}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogUI>
  );
};

export default AlertDialog;
